import { useSelector } from 'react-redux';
import {
    getEventsStatus,
    getSelectedEventId,
    getEventsSourceSetModel,
    getOpenSectionEvents,
    getEventsAsSourceSet,
    getEventsSourceSetWithFilter,
} from '.';

export const useEvents = () => useSelector(getEventsAsSourceSet);
export const useEventsSourceSetWithFilter = () =>
    useSelector(getEventsSourceSetWithFilter);
export const useEventsStatus = () => useSelector(getEventsStatus);
export const useEventId = () => useSelector(getSelectedEventId);
export const useEventsSourceSetModel = () =>
    useSelector(getEventsSourceSetModel);
export const useOpenSectionEvents = () => useSelector(getOpenSectionEvents);
